"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Metrics = void 0;

var randomIdentifier = void 0;
var raven = void 0;

randomIdentifier = require("./random_identifier");

raven = require("./raven_client").default;

Metrics = function () {
    var Metrics = function () {
        function Metrics() {
            _classCallCheck(this, Metrics);

            this.download_flow_purchase_success = this.download_flow_purchase_success.bind(this);
            this.download_flow_purchase_failure = this.download_flow_purchase_failure.bind(this);
        }

        _createClass(Metrics, [{
            key: "download",
            value: function download(download_type, file_type, icon) {
                ga("send", "event", "download", download_type, file_type);
                ga("send", "pageview", "/icon/download/complete/");

                if (window._nounConfig.collectSearchMetrics) {
                    var searchParams = void 0;
                    if (icon && icon.searchData) {
                        searchParams = {
                            icon_id: icon.id,
                            search_query: icon.searchData.query,
                            list_index: icon.searchData.resultIndex,
                            more_like_this_id: icon.searchData.moreLikeThisId,
                            collection_list_index: icon.searchData.collectionIndex
                        };
                        if (searchParams.search_query !== null || searchParams.more_like_this_id !== null) {
                            return _jquery2.default.post("/log_search_download/", searchParams).fail(function (xhr, status, error) {
                                return console.warn(error);
                            });
                        }
                    }
                }
            }
        }, {
            key: "download_failed",
            value: function download_failed(download_type, icon) {
                ga("send", "event", "download", "failed", download_type, icon);
                ga("send", "pageview", "/icon/download/failed/");
            }
        }, {
            key: "upgrade",
            value: function upgrade(data, redirect) {
                var path = void 0;
                var subscription = void 0;
                subscription = data.subscription;
                path = "/accounts/upgrade/" + subscription.plan.type + "/complete/";
                ga("send", "pageview", path);
                return ga("send", "event", "account", "upgrade", subscription.plan.name, redirect !== void 0 ? {
                    hitCallback: function hitCallback() {
                        window.location.href = redirect;
                    }
                } : void 0);
            }
        }, {
            key: "signup_form",
            value: function signup_form(account_type) {
                if (account_type == null) {
                    account_type = "basic";
                }
                return ga("send", "pageview", "/accounts/signup/" + account_type + "/");
            }
        }, {
            key: "signup_complete",
            value: function signup_complete() {
                return ga("send", "pageview", "/accounts/signup/basic/complete/");
            }
        }, {
            key: "license_options",
            value: function license_options(icon_id) {
                return ga("send", "pageview", "/icon/" + icon_id + "/download-options/");
            }
        }, {
            key: "purchase_form",
            value: function purchase_form(icon_id) {
                return ga("send", "pageview", "/icon/" + icon_id + "/purchase/");
            }
        }, {
            key: "upgrade_form",
            value: function upgrade_form(account_type) {
                if (account_type == null) {
                    account_type = "pro";
                }
                return ga("send", "pageview", "/accounts/upgrade/" + account_type + "/");
            }
        }, {
            key: "icon_hero",
            value: function icon_hero(icon_id) {
                return ga("send", "pageview", "/icon/" + icon_id + "/");
            }
        }, {
            key: "downgrade",
            value: function downgrade(user_id) {
                return ga("send", "event", "account", "downgrade", user_id);
            }
        }, {
            key: "page_depth",
            value: function page_depth(page) {
                return ga("send", "pageview");
            }
        }, {
            key: "record_purchase",
            value: function record_purchase(callback) {
                return ga("send", "pageview", "/icon/purchase/complete/", {
                    hitCallback: callback
                });
            }
        }, {
            key: "term_detail_arrow_keypress",
            value: function term_detail_arrow_keypress(permalink) {
                return ga("send", "event", "term_detail", "keypress", permalink);
            }
        }, {
            key: "tooltip_share",
            value: function tooltip_share(permalink) {
                return ga("send", "event", "tooltip", "share", permalink);
            }
        }, {
            key: "failed_upgrade",
            value: function failed_upgrade(user_id, data) {
                ga("send", "event", "upgrade", "failed", user_id);
                raven.setUserContext({
                    id: user_id
                });
                return raven.captureException(new Error(JSON.stringify(data)), {
                    tags: {
                        impact: "Failed upgrade"
                    }
                });
            }
        }, {
            key: "failed_cardsave",
            value: function failed_cardsave(user_id, data) {
                ga("send", "event", "cardsave", "failed", user_id);
                raven.setUserContext({
                    id: user_id
                });
                return raven.captureException(new Error(JSON.stringify(data)), {
                    tags: {
                        impact: "Failed card save"
                    }
                });
            }
        }, {
            key: "failed_alacarte",
            value: function failed_alacarte(user_id, data) {
                ga("send", "event", "alacarte", "failed", user_id);
                raven.setUserContext({
                    id: user_id
                });
                return raven.captureException(new Error(JSON.stringify(data)), {
                    tags: {
                        impact: "Failed a la carte purchase"
                    }
                });
            }
        }, {
            key: "user_timing",
            value: function user_timing(category, variable, timeSpent, opt_label) {
                return ga("send", "timing", category, variable, timeSpent, opt_label);
            }
        }, {
            key: "hide_lingo_upsell",
            value: function hide_lingo_upsell(user_id) {
                return ga("send", "event", "lingo_upsell", "do_not_show", user_id);
            }
        }, {
            key: "close_lingo_upsell",
            value: function close_lingo_upsell(user_id) {
                return ga("send", "event", "lingo_upsell", "hide", user_id);
            }
        }, {
            key: "lingo_cta_click",
            value: function lingo_cta_click(user_id) {
                return ga("send", "event", "lingo_upsell", "cta_click", user_id);
            }
        }, {
            key: "set_user_dimension",
            value: function set_user_dimension(user) {
                var is_anonymous = user.is_anonymous,
                    permissions = user.permissions;


                if (is_anonymous) {
                    ga("set", "dimension1", "Anonymous");
                } else if (permissions && permissions.market == "premium") {
                    ga("set", "dimension1", "Paid");
                } else {
                    ga("set", "dimension1", "Free");
                }
            }
        }, {
            key: "set_experiments_dimension",
            value: function set_experiments_dimension(experiments) {
                ga("set", "dimension2", JSON.stringify(experiments));

                ga("send", "event", "download", "flow_type", experiments.downloadFlow);
                raven.setExtraContext(experiments);
            }
        }, {
            key: "select_attribution",
            value: function select_attribution(attributionType) {
                return ga("send", "event", "download", "select_attribution", attributionType);
            }
        }, {
            key: "select_license",
            value: function select_license(license) {
                return ga("send", "event", "download", "select_license", license);
            }
        }, {
            key: "upsell_result",
            value: function upsell_result(result) {
                return ga("send", "event", "download", "upsell", result);
            }
        }, {
            key: "download_flow_purchase_success",
            value: function download_flow_purchase_success(purchaseType) {
                if (purchaseType.period) {
                    this.upgrade({
                        subscription: {
                            plan: {
                                type: purchaseType.key,
                                name: purchaseType.text
                            }
                        }
                    });
                } else {
                    this.record_purchase();
                }
            }
        }, {
            key: "download_flow_purchase_failure",
            value: function download_flow_purchase_failure(userId, purchaseType, err) {
                if (purchaseType.period) {
                    this.failed_upgrade(userId, err);
                } else {
                    this.failed_alacarte(userId, err);
                }
            }
        }, {
            key: "download_flow_color_select",
            value: function download_flow_color_select(download, color) {
                if (download.active) {
                    ga("send", "event", "download", "select_color", color);
                }
            }
        }]);

        return Metrics;
    }();

    return Metrics;
}();

exports.default = Metrics;